import React from "react";
import PropTypes from "prop-types";
// --- Import Redux
import { connect } from "react-redux";
// --- Import Componenst
import RefundForm from "../../pagesComponents/refund/RefundForm/RefundForm";
// --- Import Styles
import "./Refund.sass";

function Refund({ userData }) {
  return (
    <>
      <RefundForm userData={userData} />
    </>
  );
}

Refund.propTypes = {
  userData: PropTypes.objectOf(PropTypes.string),
};
Refund.defaultProps = {
  userData: null,
};

const mapStateToProps = (state) => ({
  userData: state.userDataStore.userData,
  dataIsLoading: state.userDataStore.userDataIsLoading,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Refund);
